import { render, staticRenderFns } from "./s_FooterMobile.vue?vue&type=template&id=a6fbce68&scoped=true&"
import script from "./s_FooterMobile.vue?vue&type=script&lang=js&"
export * from "./s_FooterMobile.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/footer_mobile.css?vue&type=style&index=0&id=a6fbce68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fbce68",
  null
  
)

export default component.exports